// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bsbwdok{width:var(--_cjikvn)}
._1e0c1ule{display:block}
._4t3iwdok{height:var(--_cjikvn)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/RelatedLinksModal/views/errored/error-svg/search-no-result/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,oBAAoB;AAC/B,WAAW,aAAa;AACxB,WAAW,qBAAqB","sourcesContent":["._1bsbwdok{width:var(--_cjikvn)}\n._1e0c1ule{display:block}\n._4t3iwdok{height:var(--_cjikvn)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
